var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg71(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7766 3.00088C22.885 3.39527 21.9438 3.64176 20.9531 3.78965C21.9438 3.19807 22.7364 2.26141 23.0831 1.12756C22.142 1.66984 21.1017 2.06422 19.9624 2.31071C19.0708 1.37405 17.7829 0.782471 16.396 0.782471C13.7211 0.782471 11.5416 2.95158 11.5416 5.61368C11.5416 6.00806 11.5911 6.35315 11.6902 6.69823C7.67786 6.50104 4.06184 4.57842 1.63464 1.62054C1.23836 2.36001 0.990692 3.14878 0.990692 4.03614C0.990692 5.71227 1.83278 7.19121 3.17021 8.07858C2.37766 8.02928 1.63464 7.83209 0.941157 7.487V7.5363C0.941157 9.9026 2.62533 11.8745 4.85439 12.3182C4.45811 12.4168 4.0123 12.4661 3.56649 12.4661C3.26928 12.4661 2.92254 12.4168 2.62533 12.3675C3.26928 14.2901 5.05253 15.7198 7.18252 15.7198C5.49834 17.0015 3.41789 17.7903 1.1393 17.7903C0.743019 17.7903 0.346742 17.7903 0 17.741C2.17952 19.1213 4.70579 19.9101 7.47972 19.9101C16.4455 19.9101 21.3494 12.5154 21.3494 6.10666C21.3494 5.90946 21.3494 5.66297 21.3494 5.46578C22.2906 4.82491 23.1327 3.98684 23.7766 3.00088Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg71);
export default __webpack_public_path__ + "static/media/svg71.4a613dd25a00e1491def09149e8f6c03.svg";
export { ForwardRef as ReactComponent };